module.exports = __webpack_public_path__ + "img/sub_support_7.1d02a860.png";